import React from "react";
import {
  FaFacebook,
  FaInstagram,
  FaWhatsapp,
  FaPinterest,
  FaEnvelope,
  FaMapMarkerAlt,
  FaBehance,
} from "react-icons/fa";
import { SiThreads } from "react-icons/si";
import logo from "../Assets/lo.png";
import { FaXTwitter } from "react-icons/fa6";
import logo1 from "../Assets/Frame Works.png";
import logo2 from "../Assets/Swift Logo.png";
import logo3 from "../Assets/HIVE.png";
import logo4 from "../Assets/INKO.png";

const Footer = () => {
  return (
    <div className="relative -mb-4 mt-4 ">
      {/* Rounded Half-Circle */}
      <div className="relative w-full h-auto md:h-[290px] max-w-screen-xl mx-auto border-t border-l border-r border-white flex flex-col items-center justify-center rounded-t-xl px-6">
        <div className="text-center w-full">
          <div className="flex flex-wrap">
            <img
              src={logo1}
              alt="logo"
              className="h-24 w-56 object-contain mx-auto"
            />
            <img
              src={logo2}
              alt="logo"
              className="h-24 w-56 object-contain mx-auto"
            />
            <img
              src={logo}
              alt="logo"
              className="h-24 w-56 object-contain mx-auto"
            />
            <img
              src={logo4}
              alt="logo"
              className="h-24 w-56 object-contain mx-auto"
            />
            <img
              src={logo3}
              alt="logo"
              className="h-24 w-56 object-contain mx-auto"
            />
          </div>
          <div className="flex flex-wrap justify-between mx-auto mt-5">
            <div className="max-w-xs space-x-2 md:ml-0 ml-4  flex">
              <FaMapMarkerAlt className="mt-5" size={24} />
              <p className=" max-w-sm  md:text-left text-center  text-sm pt-1">
                {" "}
                #22, 7<sup>th</sup> East Cross Road,<br/> Suthanthira Ponvizha Nagar,<br/>
                Gandhi Nagar, Vellore- 632006
              </p>
            </div>
            {/* Social Media Links */}
            <div className="flex md:justify-center  justify-center  md:ml-44 ml-0  w-full md:w-[30%] mx-auto mt-3 space-x-4">
              <a
                href="https://www.facebook.com/greenemeralddigitalmarketing/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook
                  size={30}
                  className="text-white hover:text-blue-600"
                />
              </a>
              <a
                href="https://www.instagram.com/greenemerald.creatives/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram
                  size={30}
                  className="text-white hover:text-pink-600"
                />
              </a>
              <a
                href="https://x.com/greenemerald_in"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaXTwitter
                  size={30}
                  className="text-white hover:text-blue-400"
                />
              </a>
              <a
                href="https://in.pinterest.com/Greenmeraldbrandingagency/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaPinterest
                  size={30}
                  className="text-white hover:text-red-600"
                />
              </a>
              <a
                href="https://www.threads.net/@greenemerald.creatives"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SiThreads
                  size={30}
                  className="text-white hover:text-gray-600"
                />
              </a>
              <a
                href="https://www.behance.net/greenemeraldagency"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaBehance
                  size={30}
                  className="text-white hover:text-blue-600"
                />
              </a>
            </div>
            <div className="mt-4 flex flex-col items-center space-y-2 text-sm">
  {/* Mobile Number */}
  <a
    href="https://wa.me/8566001166"
    target="_blank"
    rel="noopener noreferrer"
    className="flex md:justify-end justify-center  space-x-2  w-full max-w-xs hover:text-green-500"
  >
    <span>+91 8566001166</span>
    <FaWhatsapp size={20} />
  </a>
  {/* Email ID */}
  <a
    href="mailto:greenemeraldagency@gmail.com"
    className="flex md:justify-between justify-center w-full space-x-2 max-w-xs hover:text-green-500"
  >
    <span>greenemeraldagency@gmail.com</span>
    <FaEnvelope size={20} />
  </a>

</div>

          </div>
          {/* <div className="mt-4 w-56 border-t-4 border-gray-700 mx-auto"></div>/ */}
          {/*Contact Info*/}
          {/*Divider */}
          {/*Copyright*/}
        </div>
        <p className="mt-6  text-gray-500 text-center text-sm">
          &copy; {new Date().getFullYear()} <br className=" flex md:hidden" />
          <span className="text-green-500  text-sm  font-medium">
             GREEN EMERALD BRANDING AGENCY
          </span>  <br className=" flex md:hidden" />.All Rights Reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
